import * as React from 'react';
import { useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { AppProvider, AppContext, AppState } from '../../context/AppProvider';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  borderRadius:'12px',
  boxShadow: 24,
  p: 4,
};

export default function PreviewModal(props) {
  const { appData, updateAppData, view, setView , showPreview , setShowPreview } = AppState()

//   const [open , setOpen] = useState(props.open);
  const [ img , setImg ] = React.useState(props.img);
  const handleOpen = () => setShowPreview(true);
  const handleClose = () => setShowPreview(false);

    useEffect (()=>{

    },[showPreview])

  return (
    <div>
      <Modal
        open={ showPreview }
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <img src={img} width = {'100%'} />
        </Box>
      </Modal>
    </div>
  );
}